import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true, // Habilitar variables CSS personalizadas
    },
    themes: {
      light: {
        primary: '#BC3C44',
        secondary: '#FFCC00',
        accent: '#FFCC00',
        error: '#BC3C44',
        info: '#2196F3',
        success: '#2e7d32',
        warning: '#FFCC00',
        background: '#f5f5f5',
      },
      dark: {
        text: '#FFFFFF',
        primary: '#BC3C44', // FDPA Red
        secondary: '#FFCC00', // FDPA Gold
        accent: '#FFCC00',
        error: '#BC3C44',
        info: '#2196F3',
        success: '#2e7d32',
        warning: '#FFCC00',
        background: '#000000', // Black background
        panel: '#101010', // Dark panel
        hover: '#2a2a2a', // Hover state
        border: '#444444', // Borders
      },
    },
    dark: true, // Default to dark theme
  },
});